import { FC, useEffect, useState } from 'react';
import { MdDone, MdError } from 'react-icons/md';

import { UploadButton } from '@modules/invoice-generator/shared';

import { selectUserId } from '@entities/user';
import { useAppSelector } from '@shared/model';
import { errorIconStyle, rowStyle, successIconStyle } from './UploadRow.tailwind';
import { toNormalCase } from '@shared/lib/utils/text.util';

interface PropsType {
  text: string;
  value: string;
  onUpload: (formData: FormData) => Promise<boolean>;
}

const UploadRow: FC<PropsType> = ({ text, value, onUpload }) => {
  const [isUploaded, setIsUploaded] = useState<boolean>(!!value);
  const userId = useAppSelector(selectUserId);

  const handleUpload = (file: File) => {
    const formData = new FormData();

    formData.append('file', file);
    formData.append('userId', userId);

    onUpload(formData).then(setIsUploaded);
  };

  useEffect(() => {
    if (!value) {
      setIsUploaded(false);
    }
  }, [value]);

  const dataPrefix = toNormalCase(text.split(' ').pop() ?? '');

  return (
    <div className={rowStyle}>
      <UploadButton type="secondary" text={text} onUpload={handleUpload} fileTypes={['.xlsx']} />
      {isUploaded ? (
        <SuccessUpload filename={value} data-id={`p-${dataPrefix}Selected`} />
      ) : (
        <UploadException data-id={`p-${dataPrefix}NotSelected`} />
      )}
    </div>
  );
};

const SuccessUpload = (props: { filename: string; 'data-id': string }) => (
  <>
    <p data-id={props['data-id']}>{props.filename}</p>
    <MdDone className={successIconStyle} />
  </>
);

const UploadException = (props: { 'data-id': string }) => (
  <>
    <p className="items-end" data-id={props['data-id']}>
      Not Selected
    </p>
    <MdError className={errorIconStyle} />
  </>
);

export default UploadRow;
